import { render, staticRenderFns } from "./OrderDdiInfo.vue?vue&type=template&id=474283a3&"
import script from "./OrderDdiInfo.vue?vue&type=script&lang=ts&"
export * from "./OrderDdiInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports